import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { Picture } from "react-responsive-picture";
import coder from "../../assets/img/bug.jpg";
import codersmall from "../../assets/img/bugsmall.jpg";
import { Container, Row, Col } from "reactstrap";

const pageVariants = {
  initial: {
    opacity: 0,
    x: "-100vw",
    scale: 0.8,
  },
  in: {
    opacity: 1,
    x: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    x: "100vw",
    scale: 1.2,
  },
};
const pageVariants2 = {
  initial: {
    opacity: 0,
    x: "+100vw",
    scale: 0.8,
  },
  in: {
    opacity: 1,
    x: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    x: "100vw",
    scale: 1.2,
  },
};
const pageVariants3 = {
  initial: {
    opacity: 0,
    y: "+100vw",
    scale: 0.8,
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    y: "100vw",
    scale: 1.2,
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 1,
  loop: Infinity,
  repeatDelay: 10,
};

const pageStyle = {
  position: "absolute",
};

const Skills = () => {
  const [count, setCount] = useState(0);
  return (
    <div className="my">
      <div className="header">
        <div
          style={{
            position: "absolute",
            right: "20px",
            top: "130px",
            width: "100px",
          }}
        >
          <motion.svg
            whileHover={{ scale: 0.5 }}
            animate={{
              x: [-10, -20, -30, -40, -50, -60, -70, -80, -90, -100, 110],
              y: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110],
            }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              times: [0, 0.2, 0.5, 0.8, 1],
              loop: Infinity,
              repeatDelay: 2,
            }}
            class="svg-icon"
            viewBox="0 0 20 20"
          >
            <motion.path
              fill="black"
              d="M16.853,8.355V5.888c0-3.015-2.467-5.482-5.482-5.482H8.629c-3.015,0-5.482,2.467-5.482,5.482v2.467l-2.741,7.127c0,1.371,4.295,4.112,9.594,4.112s9.594-2.741,9.594-4.112L16.853,8.355z M5.888,17.367c-0.284,0-0.514-0.23-0.514-0.514c0-0.284,0.23-0.514,0.514-0.514c0.284,0,0.514,0.23,0.514,0.514C6.402,17.137,6.173,17.367,5.888,17.367z M5.203,10c0-0.377,0.19-0.928,0.423-1.225c0,0,0.651-0.831,1.976-0.831c0.672,0,1.141,0.309,1.141,0.309C9.057,8.46,9.315,8.938,9.315,9.315v1.028c0,0.188-0.308,0.343-0.685,0.343H5.888C5.511,10.685,5.203,10.377,5.203,10z M7.944,16.853H7.259v-1.371l0.685-0.685V16.853z M9.657,16.853H8.629v-2.741h1.028V16.853zM8.972,13.426v-1.028c0-0.568,0.46-1.028,1.028-1.028c0.568,0,1.028,0.46,1.028,1.028v1.028H8.972z M11.371,16.853h-1.028v-2.741h1.028V16.853z M12.741,16.853h-0.685v-2.056l0.685,0.685V16.853z M14.112,17.367c-0.284,0-0.514-0.23-0.514-0.514c0-0.284,0.23-0.514,0.514-0.514c0.284,0,0.514,0.23,0.514,0.514C14.626,17.137,14.396,17.367,14.112,17.367z M14.112,10.685h-2.741c-0.377,0-0.685-0.154-0.685-0.343V9.315c0-0.377,0.258-0.855,0.572-1.062c0,0,0.469-0.309,1.141-0.309c1.325,0,1.976,0.831,1.976,0.831c0.232,0.297,0.423,0.848,0.423,1.225S14.489,10.685,14.112,10.685z M18.347,15.801c-0.041,0.016-0.083,0.023-0.124,0.023c-0.137,0-0.267-0.083-0.319-0.218l-2.492-6.401c-0.659-1.647-1.474-2.289-2.905-2.289c-0.95,0-1.746,0.589-1.754,0.595c-0.422,0.317-1.084,0.316-1.507,0C9.239,7.505,8.435,6.916,7.492,6.916c-1.431,0-2.246,0.642-2.906,2.292l-2.491,6.398c-0.069,0.176-0.268,0.264-0.443,0.195c-0.176-0.068-0.264-0.267-0.195-0.444l2.492-6.401c0.765-1.911,1.824-2.726,3.543-2.726c1.176,0,2.125,0.702,2.165,0.731c0.179,0.135,0.506,0.135,0.685,0c0.04-0.029,0.99-0.731,2.165-0.731c1.719,0,2.779,0.814,3.542,2.723l2.493,6.404C18.611,15.534,18.524,15.733,18.347,15.801z"
            ></motion.path>
          </motion.svg>
        </div>
        <h1 className="headertitle">
          Hi, I'm Mohammad Sadman. I design and code beautifully simple things,
          and I love what I do.
        </h1>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
        }}
      >
        <Picture
          sources={[
            {
              srcSet: codersmall,
              media: "(max-width: 500px)",
            },
            {
              srcSet: coder,
            },
          ]}
        />
      </div>

      <h3 style={{ textAlign: "center", margin: "5vw" }}>
        Since beginning my journey as a developer , I've done remote work for
        agencies, and collaborated with talented people to create digital
        products for both business and consumer use. I'm quietly confident,
        naturally curious, and perpetually working on improving my skills at a
        time.
      </h3>
      <Container className="box">
        <Row>
          <Col xs="6" sm="4">
            <motion.div
              className="boxcol"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <h3
                style={{ paddingTop: "50px", fontWeight: "bold" }}
                className="skilltext"
              >
                Front-End Developent
              </h3>
              <h6 style={{ paddingTop: "20px" }} className="skilltext">
                I value simple content structure, clean design patterns, and
                thoughtful interactions.
              </h6>
              <h5
                style={{
                  paddingTop: "30px",
                  color: "#8b4be3",
                  textAlign: "center",
                }}
              >
                Languages or Frameworks or Libaries i use:
              </h5>

              <p
                style={{ paddingTop: "30px", paddingBottom: "20px" }}
                className="skilltext"
              >
                JavaScript, React.js, Redux, Framer Motion, HTML, CSS, SCSS,
                Bootstrap, Styled-Components, React Native(Android/ios Mobile
                Apps).
              </p>
            </motion.div>
          </Col>
          <Col xs="6" sm="4">
            <motion.div
              className="boxcol"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants3}
              transition={pageTransition}
            >
              <h3
                style={{ paddingTop: "50px", fontWeight: "bold" }}
                className="skilltext"
              >
                Back-End Developent
              </h3>
              <h6 style={{ paddingTop: "20px" }} className="skilltext">
                I like to code things from scratch, and enjoy bringing my ideas
                to life.
              </h6>
              <h5
                style={{
                  paddingTop: "30px",
                  color: "#8b4be3",
                  textAlign: "center",
                }}
              >
                Languages or Frameworks or Libaries i use:
              </h5>
              <p
                style={{ paddingTop: "30px", paddingBottom: "30px" }}
                className="skilltext"
              >
                JavaScript, Express.js, MongoDB, Graphql API, REST API, MYSQL,
                Web Automation.
              </p>
            </motion.div>
          </Col>
          <Col xs="6" sm="4">
            <motion.div
              className="boxcol"
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants2}
              transition={pageTransition}
            >
              <h3
                style={{ paddingTop: "50px", fontWeight: "bold" }}
                className="skilltext"
              >
                Other Skills
              </h3>

              <p
                style={{
                  paddingTop: "30px",
                  color: "black",
                  marginTop: "50px",
                  marginLeft: "20px",
                  marginRight: "20px",
                  paddingBottom: "30px",
                }}
              >
                Python, C, Github, Gitlab, Terminal, Linux, VPS Server hosting,
                Google Cloud, Heroku.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Skills;
